import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuth, getRedirectResult } from 'firebase/auth';
import { auth, app as firebaseApp } from 'src/firebase/client-app';

import { signIn } from './sign-in';

export const checkRedirectSignIn = createAsyncThunk<boolean, undefined, { rejectValue: string }>(
  'user/checkSignInRedirect',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const user = await getUser();

      if (!user) {
        throw new Error('No User');
      }

      const idToken = await user?.getIdToken(true);

      if (!idToken) {
        throw new Error('No idToken');
      }

      if (user) {
        await dispatch(
          signIn({
            // provider: user.provider,
            email: user.email || '',
            avatar: user.photoURL ?? '',
            name: user.displayName ?? '',
            idToken,
          })
        );

        return true;
      }
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }

    return false;
  }
);

async function getUser() {
  const firebaseAuth = getAuth(firebaseApp);
  const redirectResult = await getRedirectResult(firebaseAuth);

  if (redirectResult?.user) {
    return redirectResult?.user || null;
  }

  return null;
}
